module.exports = __webpack_public_path__ + "img/Bent Prong.e2a87431.png";